<template lang="html">
  <DataCard title="Stake Statistics" :data="stakeStatsArray" min-width="500" fullheight="100%"></DataCard>
</template>

<script>
// import InfoCardBig from "@/components/InfoCardBig.vue"
  // import InfoCardTable from "@/components/InfoCardTable.vue"
  import DataCard from "@/components/widgets/DataCard.vue";

  import {
    mapState
  } from 'vuex';

  export default {
    name: 'GlobalDataCards',
    components: {
      // InfoCardBig,
      // InfoCardTable,
      DataCard
    },
    // https://etherscan.io/tx/0xa009f81a0e7bed3fb331b28343ffc3f66f400024f09b8748e5a9476c73f19e3c
    data() {
      return {
        numberStakeStarts: 0,
        numberStakeEnds: 0,
        numberActiveStakes: 0,
        averageStakeLength: 0,
        weightedAverageStakeLength: 0,
        totalPaiedPenalties: 0,
      }
    },
    watch: {
      stakeStats() {
        this.updateStakeStats();
      }
    },
    computed: {
      // marketData: function() {
      //   return this.getMarketData();
      // },
      // marketDataTable: function() {
      //   return this.getMarketDataTable();
      // },
      stakeStatsArray: function() {
        return this.getStakeStats();
      },
      // stakeStatsTable: function() {
      //   return this.getStakeStatsTable();
      // },
      ...mapState({
        stakeStats: state => state.stakeStats,
      }),
    },
    mounted() {
      this.updateStakeStats();
    },
    methods: {
      isDataFetched() {
        return (
          this.$store.state.stakeStats.numberStakeStarts > -1
        );
      },
      updateStakeStats() {
        if (this.isDataFetched()) {
          this.numberStakeStarts = this.$store.state.stakeStats.numberStakeStarts;
          this.numberStakeEnds = this.$store.state.stakeStats.numberStakeEnds;
          this.numberActiveStakes = this.$store.state.stakeStats.numberActiveStakes;
          this.numberMaturedStakes = this.$store.state.stakeStats.numberMaturedStakes;
          this.numberPendingStakes = this.$store.state.stakeStats.numberPendingStakes;
          this.numberOpenStakes = this.$store.state.stakeStats.numberOpenStakes;
          this.averageStakeLength = this.$store.state.stakeStats.averageStakeLength;
          this.averageStakeSize = this.$store.state.stakeStats.averageStakeSize;
          this.weightedAverageStakeLength = this.$store.state.stakeStats.weightedAverageStakeLength;
          this.totalPaiedPenalties = this.$store.state.stakeStats.totalPaiedPenalties;
        }
      },
      getStakeStats() {
        let stakeStats = [];
        stakeStats.push({
          name: "Stakes Started",
          line1: this.$options.filters.toInt(this.numberStakeStarts, 0, ""),
          highlight: false,
        });
        stakeStats.push({
          name: "Stakes Ended",
          line1: this.$options.filters.toInt(this.numberStakeEnds, 0, ""),
          highlight: false,
        });
        stakeStats.push({
          name: "Active Stakes",
          line1: this.$options.filters.toInt(this.numberActiveStakes, 0, ""),
          highlight: true,
        });
        stakeStats.push({
          name: "   Open Stakes",
          line1: this.$options.filters.toInt(this.numberOpenStakes, 0, ""),
          highlight: false,
          indent: true,
        });
        stakeStats.push({
          name: "Matured Stakes",
          line1: this.$options.filters.toInt(this.numberMaturedStakes, 0, ""),
          highlight: false,
          indent: true,
        });
        stakeStats.push({
          name: "   Pending Stakes",
          line1: this.$options.filters.toInt(this.numberPendingStakes, 0, ""),
          highlight: false,
          indent: true,
        });
        stakeStats.push({
          name: "Average Stake Size",
          line1: this.$options.filters.toInt(this.averageStakeSize, 0, "WISE"),
          highlight: false,
        });
        stakeStats.push({
          name: "Average Stake Length",
          line1: this.averageStakeLength.toFixed(1) + " Days",
          highlight: false,
        });
        stakeStats.push({
          name: "Weighted Average Stake Length",
          line1: this.weightedAverageStakeLength.toFixed(1) + " Days",
          highlight: false,
        });
        stakeStats.push({
          name: "Total Penalty Payed",
          line1: this.$options.filters.toInt(this.totalPaiedPenalties, 0, "WISE"),
          highlight: false,
        });
        return stakeStats
      },
    }
  }
</script>

<style lang="css" scoped>
</style>
